import React, { useState, useEffect } from "react";
import axios from "axios";
import Navbar from "../../Components/Navbar";
import ReportProgress from "../../Components/ReportProgress";
import { Form } from "react-bootstrap";
import "./UploadFiles.css";
import DownloadIcon from "@mui/icons-material/Download";
import { API_BASE_URL } from "../../config";

export default function ProgressReport() {
  const [selectedReport, setSelectedReport] = useState("");
  const [projects, setProjects] = useState([]);
  const [selectedAppId, setSelectedAppId] = useState("");
  const [projectTitle, setProjectTitle] = useState("");

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/GetApplicationID.php`);
        setProjects(response.data);
      } catch (error) {
        console.error("Error fetching projects:", error);
      }
    };
    fetchProjects();
  }, []);

  const handleReportChange = (event) => setSelectedReport(event.target.value);

  const handleProjectChange = (event) => {
    const appId = +event.target.value;
    setSelectedAppId(appId);
    const selectedProject = projects.find(
      (project) => project.app_ID === appId
    );
    setProjectTitle(selectedProject ? selectedProject.projectTitle : "");
  };

  const getTemplateDownloadLink = () => {
    switch (selectedReport) {
      case "mid-year":
        return {
          link: "/Templates/Six Months Progresss Evaluation.docx",
          filename: "Six Months Progresss Evaluation.docx",
          label: "Mid Year Report Template",
        };
      case "end-year":
        return {
          link: "/Templates/One Year Progress Evaluation.docx",
          filename: "One Year Progress Evaluation.docx",
          label: "End Year Report Template",
        };
      case "final":
        return {
          link: "/Templates/Final Report Evaluation.docx",
          filename: "Final Report Evaluation.docx",
          label: "Final Report Template",
        };
      default:
        return null;
    }
  };

  const templateDownloadInfo = getTemplateDownloadLink();

  return (
    <div>
      <Navbar />

      {/* 4-Column White Box Section */}
      <div className="progress-upload-box">
        {/* Column 1: Application ID */}
        <div className="progress-column">
          <Form.Group controlId="appIdSelect">
            <Form.Label className="selecttitle">
              Select Application ID:
            </Form.Label>
            <Form.Control
              className="appid_dropdown"
              as="select"
              value={selectedAppId}
              onChange={handleProjectChange}
            >
              <option value="">-- Select Application ID --</option>
              {projects.map((project) => (
                <option key={project.app_ID} value={project.app_ID}>
                  {project.app_ID}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
        </div>

        {/* Column 2: Project Title */}
        <div className="progress-column">
          <Form.Group controlId="projectTitleDisplay">
            <Form.Label className="selecttitle">Project Title:</Form.Label>
            <Form.Control
              className="project_dropdown"
              type="text"
              value={projectTitle}
              readOnly
            />
          </Form.Group>
        </div>

        {/* Column 3: Report Type */}
        <div className="progress-column">
          <Form.Group controlId="reportSelect">
            <Form.Label className="selecttitle">Select Report Type:</Form.Label>
            <Form.Control
              as="select"
              value={selectedReport}
              onChange={handleReportChange}
              className="project_dropdown"
            >
              <option value="">-- Select Report Type --</option>
              <option value="mid-year">Mid Year Report</option>
              <option value="end-year">End Year Report</option>
              <option value="final">Final Report</option>
            </Form.Control>
          </Form.Group>
        </div>

        {/* Column 4: Download Link */}
        <div className="progress-column">
          {templateDownloadInfo && (
            <div>
              <Form.Label className="downloadtitle2">
                Download Template:
              </Form.Label>
              <p>
                <a
                  href={templateDownloadInfo.link}
                  download={templateDownloadInfo.filename}
                  className="template-link2"
                >
                  {templateDownloadInfo.label}
                  <DownloadIcon
                    style={{ fontSize: "1.5rem", marginLeft: "0.5rem" }}
                  />
                </a>
              </p>
            </div>
          )}
        </div>
      </div>

      {/* Upload Title */}
      <label className="uploadtitle">Upload Report Here 👇</label>

      {/* Conditionally Render ReportProgress */}
      {selectedReport && selectedAppId && (
        <ReportProgress reportType={selectedReport} appId={selectedAppId} />
      )}
    </div>
  );
}
